import {
	Button,
	Chip,
	FormControl,
	InputLabel,
	makeStyles,
	MenuItem,
	Select,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import addLeadToClient from '../../../api/SendEmails/addLeadToClient.api';
import assignLead from '../../../api/SendEmails/assignLead.api';
import SearchBox from '../../searchBox/SearchBox';
import styles from './SelectBox.module.scss';

const SelectBox = ({
	leadEmails,
	handleSelectEmail,
	path,
	handleCloseLeads,
	salesAgents,
	setFilteredLeadEmails,
	setAlert,
	snackbar,
	setSnackbar,
	setSnackbarType,
}) => {
	const [searchField, setSearchField] = useState('');
	const [filteredClients, setFilteredClients] = useState();
	const [leadToSalesAgent, setleadToSalesAgent] = useState();
	const [sent, setSent] = useState('sent');

	//search functionality
	useEffect(() => {
		var filtered;
		if (sent === 'sent') {
			filtered = leadEmails?.filter((email) => {
				if (email.sentEmail === true) {
					return email.email
						.toLowerCase()
						.includes(searchField.toLowerCase());
				}
			});
		} else if (sent === 'unsent') {
			filtered = leadEmails?.filter((email) => {
				if (email.sentEmail !== true) {
					return email.email
						?.toLowerCase()
						.includes(searchField.toLowerCase());
				}
			});
		}

		var filteredEmailArr = [];

		filtered && filtered.map((email) => filteredEmailArr.push(email.email));

		setFilteredLeadEmails && setFilteredLeadEmails(filteredEmailArr);

		console.log('filterrr', filteredEmailArr);
		setFilteredClients(filtered);
	}, [searchField, leadEmails, sent]);

	const useStyles = makeStyles(() => ({
		chip: {
			margin: '5px',
		},
		add_client_button: {
			height: '32px',
			marginTop: '5px',
		},
		assign_sales_agent_dd: {
			minWidth: '18em',
		},
	}));

	const classes = useStyles();

	const handleChange = (e) => {
		setSearchField(e.target.value);
	};

	const onChange = (e) => {
		var salesAgentValue = e.target?.value;
		var email = e.target.name;

		if (salesAgentValue) {
			setleadToSalesAgent({
				...leadToSalesAgent,
				[email]: e?.target?.value,
			});
		}
	};

	const handleSaveAssignLead = () => {
		if (leadToSalesAgent) {
			assignLead(leadToSalesAgent);
		}
		handleCloseLeads();
	};

	return (
		<>
			<div className={styles.filter_select_group}>
				<div
					className={`${styles.filter_btn} ${
						sent === 'sent' ? styles.active : ''
					}`}
					onClick={() => setSent('sent')}
				>
					Sent
				</div>
				<div
					className={`${styles.filter_btn} ${
						sent === 'unsent' ? styles.active : ''
					}`}
					onClick={() => setSent('unsent')}
				>
					Unsent
				</div>
			</div>
			<div className={styles.select_box}>
				<div className={styles.inner_select_box}>
					<SearchBox
						placeholder='Search emails'
						handleChange={handleChange}
					/>
					{filteredClients?.map((email) => {
						return (
							<div className={styles.client_group}>
								<Chip
									label={email.email}
									className={classes.chip}
									data-email={email.email}
									onClick={(e) => handleSelectEmail(e)}
								/>
								{path === 'client' && (
									<Button
										variant='contained'
										color='primary'
										className={classes.add_client_button}
										onClick={() => {
											addLeadToClient(
												email.email,
												setAlert,
												snackbar,
												setSnackbar,
												setSnackbarType
											);
											handleCloseLeads();
										}}
									>
										Add as client
									</Button>
								)}
								{path === 'assign-lead' && salesAgents && (
									<FormControl
										variant='outlined'
										className={
											classes.assign_sales_agent_dd
										}
										required
									>
										<InputLabel id='demo-simple-select-outlined-label'>
											Assign lead to sales agent
										</InputLabel>
										<Select
											labelId='demo-simple-select-outlined-label'
											id='demo-simple-select-outlined'
											value={leadToSalesAgent}
											name={email.email}
											onChange={(e) => onChange(e)}
											label='Assign lead to sales agent'
										>
											<MenuItem value=''>None</MenuItem>
											{salesAgents.map((salesAgent) => {
												return (
													<MenuItem
														value={salesAgent}
													>
														{
															salesAgent.salesAgentName
														}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								)}
							</div>
						);
					})}
				</div>
			</div>

			{path === 'assign-lead' && (
				<Button
					className={styles.save_btn}
					variant='contained'
					color='primary'
					type='submit'
					onClick={handleSaveAssignLead}
				>
					Save
				</Button>
			)}
		</>
	);
};

export default SelectBox;
